module.exports = {
    register: 0,
    login: 1,
    tryAutoLogin: 2,
};


/** WEBPACK FOOTER **
 ** ./src/constants/process-type.js
 **/